const fetch = require("isomorphic-fetch");
import { callService } from "../tools";
import { servicios } from "../properties";



 export const dentaliaBeneficios = (BeneficiosDentalia) =>{
    
    return dispatch =>{
        let ramoPoliza = BeneficiosDentalia;
        
        let request ={
                
            "ramo": ramoPoliza,
            
        };
        let DentaliaCallBeneficio = new callService({
            service: "planDentalia.dentaliaBeneficio",
            "secure": true,
          
            data: request,
            json:true
        }).execute().then(BeneficiosDentalia=>{
    

         dispatch({ "type": "DENTALIA_BENEFICIO", BeneficiosDentalia});
             
         }).catch(() => {
            console.log("Error en Beneficios Dentalia");
             });
 
         }        
    
 };

export const obtenerTratamientoDentalia =  (TratamientoDentalia)=>{
 
    
    return dispatch =>{
        let spoliza=TratamientoDentalia;
      
        let request ={  
           
            "poliza": spoliza,
            
        };
        let DentaliObtenerbeneficio = new callService({
            service: "planDentalia.tratamientoDentalia",
            "secure": true,
            data: request,
            json:true
        }).execute().then((TratamientoDentalia) => { 
        
            dispatch({ "type": "DENTALIA_TRATAMIENTO", TratamientoDentalia});
               
            }).catch(() => {
                    console.log("Error en Tratamiento Dentalia: ");
                });
    
            }        
            
};

export const obtenerSumaDentalia = (sumaPoliza, sumaRamo)=>{
    return dispatch => {
        let spoliza = sumaPoliza;
        let sramo = sumaRamo;

        let request ={
            "poliza": spoliza,
            "montoMinimo": "500000"
        };

        if(sramo ==="V"){
        let llamadaDentaliasumaDentalia = new callService({
            service: "planDentalia.sumaDentalia",
            "secure": false,
          
            data: request,
            json:true
        }).execute().then(SumaDentalia=>{
         
            dispatch({ "type": "DENTALIA_SUMA", SumaDentalia});
             

        }).catch(() => {
            console.log("Error en suma Dentalia");
        });
    }
    else{
        console.log("Error, El ramo no tiene permiso");
    }
    };
};

export const PermisosAsistenciaDental = (PermisoProductivo,PermisoComercial) =>{

    return dispatch =>{
        let claveProductiG = PermisoProductivo;
        let cveProdComercial = PermisoComercial
    
        let request ={
            "permisos":claveProductiG+"-"+cveProdComercial
        };
        let permisos = new callService({
            service: "planDentalia.permisoAsistenciaDentalG",
            "secure": true,
            data: request,
            json:true
        }).execute().then((PermisoAsis) => { 
       
         dispatch({ "type": "DENTALIA_PERMISO_DENTAL", PermisoAsis});
             
         }).catch(() => {
            console.log("Error en Asistencia GMM");
             });
 
         }        
         
 
 };


// WEBPACK FOOTER //
// ./src/home/dentalia.act.js